import React, { useContext, useEffect } from "react";
import { CycleFilterContext } from "../overview/context/CycleFilterContext";
import { PVAOverviewContext } from "../overview/context/PVAOverviewContext";
import ChartView from "../chart/ChartView";
import PackageOverview from "../packageOverview/PackageOverview";
import { getRefreshInterval } from "./utils/utils";
import { getDocumentURL } from "../handler/ParentDataHandler";
import { getBaseUrl } from "../outboundAmzl/util/Util";

const PVAView = (data) => {
  const { cycles } = useContext(CycleFilterContext);
  const { dispatch } = useContext(PVAOverviewContext);

  const getPVAData = () => {
    getDocumentURL().then((result) => {
      const baseUrl = getBaseUrl(result);
      dispatch({
        type: "LOAD_PVA_DATA",
        data: {
          filter: cycles,
          dispatcher: dispatch,
          processName: data.pva.processName,
          baseUrl: baseUrl,
        },
      });
    });
  };

  useEffect(() => {
    if (cycles.allCycles.length > 0) {
      getPVAData();
      const interval = setInterval(() => {
        if (!document.hidden) {
          getPVAData();
        }
      }, getRefreshInterval());
      return () => clearInterval(interval);
    }
  }, [cycles]);

  return (
    <div>
      <ChartView view={{ processName: data.pva.processName }} />
      <PackageOverview view={{ processName: data.pva.processName }} />
    </div>
  );
};

export default PVAView;



// WEBPACK FOOTER //
// ./src/components/overview/PVAView.js